import React from 'react';
import EQKnobWithScale, { EQSection, EQLabel } from './EQKnob';

const EQControls = ({ eqRotation, onEQMouseDown, onEQClick, knobConfig }) => {
    return (
        <>
            <EQSection>
                <EQKnobWithScale
                    type="high"
                    rotation={eqRotation.high}
                    onMouseDown={(e) => onEQMouseDown('high', e)}
                    onTouchStart={(e) => onEQMouseDown('high', e)}
                    onClick={(e) => onEQClick('high', e)}
                    {...knobConfig}
                />
                <EQLabel>High</EQLabel>
            </EQSection>
            <EQSection>
                <EQKnobWithScale
                    type="mid"
                    rotation={eqRotation.mid}
                    onMouseDown={(e) => onEQMouseDown('mid', e)}
                    onTouchStart={(e) => onEQMouseDown('mid', e)}
                    onClick={(e) => onEQClick('mid', e)}
                    {...knobConfig}
                />
                <EQLabel>Mid</EQLabel>
            </EQSection>
            <EQSection>
                <EQKnobWithScale
                    type="low"
                    rotation={eqRotation.low}
                    onMouseDown={(e) => onEQMouseDown('low', e)}
                    onTouchStart={(e) => onEQMouseDown('low', e)}
                    onClick={(e) => onEQClick('low', e)}
                    {...knobConfig}
                />
                <EQLabel>Low</EQLabel>
            </EQSection>
        </>
    );
};

export default EQControls;

